import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  constructor(private http: HttpClient) { }

  getRoleList(query): Observable<any> {
    return this.http.get(API_URL + 'userrole/?' + query);
  }

  updateRole(id, userroledata): Observable<any> {
    return this.http.put(API_URL + 'userrole/' + id, userroledata);
  }

  getRoleDetails(id): Observable<any> {
    return this.http.get(API_URL + "userrole/" + id);
  }

  searchRoleDetails(querystring): Observable<any> {
    return this.http.get(API_URL + 'userrole/?' + querystring);
  }

  addRole(roledata): Observable<any> {
    return this.http.post(API_URL + 'userrole', roledata);
  }
  getRoleListWithoutAuth(query): Observable<any> {
    return this.http.get(API_URL + 'userrole/v1/?' + query);
  }

  setCurrentActiveRoute(url:string) {
    let currentRouteObj = {
      contest: ((url.includes('/contest') || url === '/contest-leaderboard') && url !== '/contest-history') ? true : false,
      myContest: (url === '/contest-history') ? true : false,
      tournaments: (url.includes('/tournaments')) ? true : false,
      findPartner: (url.includes('/find-partner') || url === '/my-schedule') ? true : false,
      eshop: (url === '/product') ? true : false,
      academy: (url.includes('/academies')) ? true : false,
      rankings: (url === '/leaderboard') ? true : false
    };
    window.localStorage.setItem('currentRouteObj1',JSON.stringify(currentRouteObj));
    window.localStorage.setItem('AboutTpl',JSON.stringify(false));
  }

  setCurrentActiveRoute2(url:string) {
    let currentRouteObj = {
      abouttheleague: (url === '/about-the-league') ? true : false,
      standings: (url === '/scoretable') ? true : false,
      teams: (url === '/teams') ? true : false,
      sponsors: (url === '/sponsors') ? true : false,
      media: (url === '/media') ? true : false,
      highlights: (url === '/highlights') ? true : false
    }
    window.localStorage.setItem('currentRouteObj2',JSON.stringify(currentRouteObj));
    window.localStorage.setItem('AboutTpl',JSON.stringify(true));
  }
}
